import { useEffect, useState } from 'react';
import { api } from '../../../api/client';

export default function BehaviorPage() {
  const [records, setRecords] = useState<any[]>([]);
  const [students, setStudents] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [filterStudent, setFilterStudent] = useState('');
  const [filterType, setFilterType] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ studentId: '', type: 'OBSERVATION', description: '' });

  const fetchData = () => {
    const params: Record<string, string> = {};
    if (filterStudent) params.studentId = filterStudent;
    if (filterType) params.type = filterType;
    Promise.all([
      api.get('/api/behavior', { params }),
      api.get('/api/students').catch(() => []),
    ]).then(([rec, stu]) => {
      setRecords(rec as any[]);
      setStudents(Array.isArray(stu) ? stu : []);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchData();
  }, [filterStudent, filterType]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await api.post('/api/behavior', form);
    setShowForm(false);
    setForm({ studentId: '', type: 'OBSERVATION', description: '' });
    fetchData();
  };

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Cargando...</div>;

  return (
    <div className="p-8" style={{ minHeight: '100vh' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 24,
        }}
      >
        <h1 style={{ fontSize: 28, fontWeight: 700, color: '#1a1c2c' }}>
          📋 Conducta / Disciplina
        </h1>
        <button
          onClick={() => setShowForm(!showForm)}
          style={{
            background: 'var(--primary-gradient)',
            color: '#fff',
            padding: '10px 20px',
            borderRadius: 8,
            border: 'none',
            cursor: 'pointer',
            fontWeight: 600,
          }}
        >
          + Nuevo Registro
        </button>
      </div>

      <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
        <select
          value={filterStudent}
          onChange={(e) => setFilterStudent(e.target.value)}
          style={{
            padding: 8,
            borderRadius: 8,
            border: '1px solid #e0e0e0',
            background: '#fff',
            minWidth: 200,
          }}
        >
          <option value="">Todos los alumnos</option>
          {students.map((s: any) => (
            <option key={s.id} value={s.id}>
              {s.firstName} {s.paternalLastName}
            </option>
          ))}
        </select>
        <select
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
          style={{ padding: 8, borderRadius: 8, border: '1px solid #e0e0e0', background: '#fff' }}
        >
          <option value="">Todos los tipos</option>
          <option value="POSITIVE">Positivo</option>
          <option value="NEGATIVE">Negativo</option>
          <option value="OBSERVATION">Observación</option>
        </select>
      </div>

      {showForm && (
        <form
          onSubmit={handleSubmit}
          style={{
            background: '#fff',
            borderRadius: 12,
            padding: 20,
            marginBottom: 24,
            maxWidth: 500,
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          }}
        >
          <div style={{ marginBottom: 12 }}>
            <select
              value={form.studentId}
              onChange={(e) => setForm({ ...form, studentId: e.target.value })}
              required
              style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #ddd' }}
            >
              <option value="">Seleccionar alumno</option>
              {students.map((s: any) => (
                <option key={s.id} value={s.id}>
                  {s.firstName} {s.paternalLastName}
                </option>
              ))}
            </select>
          </div>
          <div style={{ marginBottom: 12 }}>
            <select
              value={form.type}
              onChange={(e) => setForm({ ...form, type: e.target.value })}
              required
              style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #ddd' }}
            >
              <option value="POSITIVE">Positivo (logro / buena conducta)</option>
              <option value="NEGATIVE">Negativo (falta / mala conducta)</option>
              <option value="OBSERVATION">Observación general</option>
            </select>
          </div>
          <div style={{ marginBottom: 16 }}>
            <textarea
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              placeholder="Descripción detallada"
              required
              rows={4}
              style={{
                width: '100%',
                padding: 10,
                borderRadius: 8,
                border: '1px solid #ddd',
                resize: 'vertical',
              }}
            />
          </div>
          <button
            type="submit"
            style={{
              background: 'var(--primary-color)',
              color: '#fff',
              padding: '10px 20px',
              borderRadius: 8,
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Guardar
          </button>
        </form>
      )}

      <div style={{ display: 'grid', gap: 10 }}>
        {records.map((r: any) => (
          <div
            key={r.id}
            style={{
              background: '#fff',
              borderRadius: 12,
              padding: 16,
              borderLeft: `4px solid ${r.type === 'POSITIVE' ? '#4caf50' : r.type === 'NEGATIVE' ? '#ff2d55' : '#2196f3'}`,
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
              <div>
                <span
                  style={{
                    padding: '2px 8px',
                    borderRadius: 4,
                    fontSize: 12,
                    fontWeight: 600,
                    background:
                      r.type === 'POSITIVE'
                        ? '#4caf5033'
                        : r.type === 'NEGATIVE'
                          ? '#ff2d5533'
                          : '#2196f333',
                    color:
                      r.type === 'POSITIVE'
                        ? '#4caf50'
                        : r.type === 'NEGATIVE'
                          ? '#ff2d55'
                          : '#2196f3',
                  }}
                >
                  {r.type === 'POSITIVE'
                    ? '🌟 Positivo'
                    : r.type === 'NEGATIVE'
                      ? '⚠️ Negativo'
                      : '📝 Observación'}
                </span>
                <strong style={{ marginLeft: 8 }}>
                  {r.student?.firstName} {r.student?.paternalLastName}
                </strong>
              </div>
              <span style={{ fontSize: 12, color: '#888' }}>
                {new Date(r.createdAt).toLocaleString('es-MX')}
              </span>
            </div>
            <p style={{ margin: 0, fontSize: 14, color: '#555' }}>{r.description}</p>
            <div style={{ fontSize: 12, color: '#888', marginTop: 6 }}>
              Registrado por: {r.recordedBy?.name}
            </div>
          </div>
        ))}
        {records.length === 0 && (
          <p style={{ textAlign: 'center', color: '#888', padding: 40 }}>
            Sin registros de conducta
          </p>
        )}
      </div>
    </div>
  );
}
